import setupRoutes from '@/navigation/vertical/admin/setup'
import designRoutes from '@/navigation/vertical/admin/design'
import marketingRoutes from '@/navigation/vertical/admin/marketing'
import managementRoutes from '@/navigation/vertical/admin/management'

import USER_TYPES from '@/constants/authorization/user-types'

const branchAdminRoutes = [...setupRoutes, ...designRoutes]

const items = [
  {
    title: 'navigation.dashboard',
    route: 'admin:dashboard',
    svgIcon: 'icon-dashboard',
  },
  ...branchAdminRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.BRANCH_ADMIN] })),
  ...marketingRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR] })),
  ...managementRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_USER] })),
  {
    title: 'navigation.payment-links',
    route: 'admin:payment-links',
    svgIcon: 'icon-payment-links',
    userTypes: [USER_TYPES.OWNER],
  },
  {
    title: 'navigation.branches-management',
    route: 'admin:branches-management',
    svgIcon: 'icon-branches',
    userTypes: [USER_TYPES.OWNER],
  },
  {
    title: 'navigation.settings',
    route: 'admin:settings',
    svgIcon: 'icon-settings',
    userTypes: [USER_TYPES.OWNER],
  },
]

export default items
